<template>
  <section>
    <b-card>
      <h3 class="mb-1 font-weight-bolder">
        {{ $t('Global.Filters') }}
      </h3>
      <b-row>
        <b-col lg="3" md="4" sm="12">
          <label>
            {{ $t('Management.Sorts.Group') }}
          </label>
          <v-select
            v-model="filter.group"
            :placeholder="$t('Global.Filter')"
            :options="Groups"
          >
          <div slot="no-options">{{ $t("Global.NothingFound") }}</div>
            <template #option="{ label }">
              <div>{{ $t(`Management.Sorts.Groups.${label}`) }}</div>
            </template>
            <template #selected-option="{ label }">
              <div>{{ $t(`Management.Sorts.Groups.${label}`) }}</div>
            </template>
          </v-select>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body>
      <div
        class="custom-search d-flex justify-content-between align-items-center mb-2 px-2 pt-2"
      >
        <h2 class="m-0 font-weight-bolder">
          {{ $t('Global.All') }} {{ $t('Management.Sorts.Sorts') }}
        </h2>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="searchTerm"
              :placeholder="$t('Global.Search')"
              type="text"
              class="d-inline-block search"
            />
          </div>
          <Create
            v-if="$can($acl.action.Create, $acl.subjects.Sorts)"
            @add="addEntry"
          />
        </div>
      </div>

      <Table
        :rows="rowData"
        :search-term="searchTerm"
        @delete="deleteRow"
      />
    </b-card>
  </section>
</template>

<script>
import { BFormInput, BCard, BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

import { Groups } from '@/data/enums'
import deleteEntry from '@/utility/scripts/delete'

import Create from './components/create.vue'
import Table from './components/table.vue'

export default {
  components: {
    BFormInput,
    BCard,
    BRow,
    BCol,
    vSelect,

    Create,
    Table,
  },

  data: () => ({
    filter: {
      group: null,
    },
    searchTerm: '',
    rows: [],
    Groups,
  }),

  computed: {
    rowData() {
      return this.rows.filter(x => {
        if (this.filter.group === null) return true
        return this.filter.group === x.group
      })
    },
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      try {
        const { data } = await this.$axios.get('sorts')
        this.rows = data
      } catch (error) {
        this.$alert.error()
      }
    },
    addEntry(entry) {
      this.rows.push(entry)
    },
    async deleteRow(row) {
      try {
        const id = await deleteEntry(this, {
          id: row.id,
          article: `${this.$t('Global.Articles_2')}`,
          subject: `${this.$t('Management.Sorts.Sort')}`,
          individual: `"${row.name}"`,
          endpoint: 'sorts/',
        })
        
        this.rows = this.rows.filter(x => x.id !== id)
      } catch (error) {
        // continue regardless of error
      }
    },
  },
}
</script>
